module.exports = __webpack_public_path__ + "img/logo-header.aa94e2e6.png";